import Dexie, { type Table } from 'dexie';
import type { Shot } from '../types';

export interface QueuedScoreWrite {
  id: string;
  eventId: string;
  shots: Shot[];
  createdAt: number;
  attempts: number;
  lastError?: string;
}

class DeadBirdFieldDatabase extends Dexie {
  scoreWrites!: Table<QueuedScoreWrite, string>;

  constructor() {
    super('deadbird-field');
    this.version(1).stores({
      scoreWrites: 'id, eventId, createdAt',
    });
  }
}

const database = new DeadBirdFieldDatabase();

export const queueScoreWrite = async (write: Omit<QueuedScoreWrite, 'attempts'>): Promise<void> => {
  await database.scoreWrites.put({ ...write, attempts: 0 });
};

export const getQueuedScoreWrites = async (eventId?: string): Promise<QueuedScoreWrite[]> => {
  const writes = eventId
    ? await database.scoreWrites.where('eventId').equals(eventId).toArray()
    : await database.scoreWrites.toArray();
  return writes.sort((first, second) => first.createdAt - second.createdAt);
};

export const getQueuedScoreCount = async (eventId?: string): Promise<number> => {
  return eventId
    ? database.scoreWrites.where('eventId').equals(eventId).count()
    : database.scoreWrites.count();
};

export const removeQueuedScoreWrite = async (id: string): Promise<void> => {
  await database.scoreWrites.delete(id);
};

export const markQueuedScoreFailed = async (id: string, error: string): Promise<void> => {
  const current = await database.scoreWrites.get(id);
  if (!current) return;
  await database.scoreWrites.update(id, {
    attempts: current.attempts + 1,
    lastError: error,
  });
};

export const clearQueuedScoresForEvent = async (eventId: string): Promise<void> => {
  await database.scoreWrites.where('eventId').equals(eventId).delete();
};
